import plugin from './src/style-observer.plugin.js';
export default plugin;